import React, { useState } from "react";

import { Modal, Input, Form, message } from "antd";

import b2bInvoiceService from "Network/lib/b2bInvoiceService";

function SendBackModal({ isOpen, onClose, caseId, stageType, onSuccess, submitFn }) {
  const [form] = Form.useForm();
  const [submitting, setSubmitting] = useState(false);
  const submit = submitFn || b2bInvoiceService.sendBackStage;

  const handleOk = () => {
    form
      .validateFields()
      .then(({ comment }) => {
        if (!caseId || !stageType) {
          message.error("Missing approval context");
          return;
        }
        setSubmitting(true);
        return submit(caseId, stageType, { comment: comment.trim() })
          .then(() => {
            message.success("Sent back");
            form.resetFields();
            onSuccess?.();
          })
          .catch(() => message.error("Send back failed"))
          .finally(() => setSubmitting(false));
      })
      .catch(() => {
        // validation error - antd shows inline
      });
  };

  const handleCancel = () => {
    form.resetFields();
    onClose();
  };

  return (
    <Modal
      title="Send Back with Comment"
      open={isOpen}
      onOk={handleOk}
      onCancel={handleCancel}
      okText="Send Back"
      cancelText="Cancel"
      confirmLoading={submitting}
      destroyOnClose
    >
      <Form form={form} layout="vertical">
        <Form.Item
          name="comment"
          label="Comment"
          rules={[
            { required: true, message: "Comment is required" },
            {
              validator: (_, value) =>
                value && value.trim().length > 0
                  ? Promise.resolve()
                  : Promise.reject(new Error("Comment cannot be empty"))
            }
          ]}
        >
          <Input.TextArea rows={4} placeholder="Why is this being sent back?" maxLength={500} showCount />
        </Form.Item>
      </Form>
    </Modal>
  );
}

export default SendBackModal;
